<template>
  <div class="p_t">
    <TopHead title="获奖展示"></TopHead>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul class="list">
          <li v-for="item in list" :key="item.contentId" @click="showPopImgBig(item)">
            <img :src="item.coverUrl" alt>
            <p>{{item.title}}</p>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>

    <div class="p_f img_big_out" v-if="showPopImg" @click.stop="showPopImg = false">
      <!--<div class="close_img p_a" @click="showPopImg = false">×</div>-->
      <img :src="bigSrc" alt="" @click.stop="showPopImg = true">
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        params: {
          pageIndex: 1,
          pageSize: 8,
          columnCode: ""
        },
        list: [],
        refreshing: false,
        loading: true,
        finished: false,
        showPopImg: false,
        bigSrc: ''
      };
    },
    created() {
      this.params.columnCode = this.$route.query.code;
      this.getList();
    },
    methods: {
      showPopImgBig(row){
        this.bigSrc = row.coverUrl;
        this.showPopImg = true
      },
      getList() {
        this.$api.listContent(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if (res.data.recordCount) {
            this.list = this.list.concat(
              JSON.parse(JSON.stringify(res.data.rows))
            );
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        });
      },
      onRefresh() {
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.getList();
      },
      onLoad() {
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.getList();
      }
    }
  };
</script>
<style lang="scss" scoped>
  .img_big_out{
    .close_img{
      font-size: 26px;
      color: #ffffff;
      background-color: #ff8038;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      cursor: pointer;
      font-weight: lighter;
    }
    img{
      width: 90%;
      /*height: 100%;*/
    }
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 50PX;
    box-sizing: border-box;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .list {
    padding: 34px 15px;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 148px;
      text-align: center;
      margin-bottom: 30px;
      font-size: 10px;
      color: #333333;
      img {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        border-radius: 5px;
        box-shadow: 2px 2px 2px 2px #b1b1b1;
      }
    }
    li:nth-child(even) {
      margin-left: auto;
    }
  }
</style>
